import {
  FaDollarSign,
  FaCalendarAlt,
  FaUser,
  FaUsers,
} from 'react-icons/fa';
import { PiBuildingsFill } from "react-icons/pi";
import { FaFolderOpen } from "react-icons/fa6";
import { RiDashboardFill } from "react-icons/ri";
import { RiTeamFill } from "react-icons/ri";
import { TbHierarchy2 } from "react-icons/tb";
import { AiFillDatabase } from "react-icons/ai";
import { BiCategory } from 'react-icons/bi';

export const personalModeSidebar = [
  { name: "Dashboard", icon: RiDashboardFill, link: "/dashboard/shared" },
  { name: "Company", icon: PiBuildingsFill, link: "/company" },
  { name: "Category", icon: BiCategory, link: "/category" },
  { name: "Units", icon: FaDollarSign, link: "/units" },
  { name: "Time Period", icon: FaCalendarAlt, link: "/time-period" },
];

export const businessAndEnterpriseModeTeamSidebar = [
  {
    name: "Dashboard",
    link: "/dashboard",
    icon: RiDashboardFill,
  },
  {
    name: "Drive",
    icon: FaFolderOpen,
    children: [
      { name: "Personal Drive", link: "/personal/drive", icon: FaUser },
      { name: "Team/Member Drive", link: "/teams/drive", icon: FaUsers },
    ],
  },
  {
    name: "Company Structure",
    icon: PiBuildingsFill,
    children: [
      { name: "Employees", link: "/company/employees", icon: RiTeamFill },
      { name: "Team Hierarchy", link: "/company/team-hierarchy", icon: TbHierarchy2 },
    ],
  },
  {
    name: "Financial Data Entries",
    link: "/entries",
    icon: AiFillDatabase,
  },
];

export const companyMemberSidebar = [
  {
    name: "Dashboard",
    link: "/dashboard",
    icon: RiDashboardFill,
  },
]
